module.exports = __webpack_public_path__ + "img/1542562289.6e326522.jpg";